import { useEffect } from 'preact/hooks';
import { useSessionStorage } from '@/hooks';
import { createId } from '@/utils';
import { useFormProps } from '../stores/ConfigStore';

export default function useCustomerId(formIsCompleted) {
	const { formKey, multipleIndex } = useFormProps();
	const [id, setId] = useSessionStorage(
		`${formKey}.cid.${multipleIndex ?? 0}`,
		createId(10)
	);

	useEffect(() => {
		if (formIsCompleted) {
			setId(createId(10));
		}
	}, [formIsCompleted]);

	return id;
}
